import React from 'react';

export default function WBSDifferent() {
    return (
        <div>
            WBS Different View
        </div>
    );
}
